import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../../assets/css/customer/venues/VenueHeadingSection.css';

const VenueHeadingSection = () => {
  return (
     <section className="contact-hero-section">
         <Container>
           <div className="contact-hero-content">
             {/* Main Heading */}
             <h1 className="contact-hero-heading">Venues</h1>
   
             {/* Description */}
             <p className="contact-hero-description">
              Explore stunning wedding venues that match your style, budget, and preferences to make your big day truly unforgettable.
             </p>
           </div>
         </Container>
       </section>
  );
};
  
export default VenueHeadingSection;